import { ca } from '@cian/analytics';

import { trackingPageType } from './trackSubscriptionDelete';

import type { IPage } from './common';

export interface ITrackFrequencyChangeParams {
  label: string;
  page: IPage;
}

/**
 * Отслеживает изменение регулярности оповещений в подписках
 * @param {string} label
 * @param {IPage} page
 */
export function trackFrequencyChange({ label, page }: ITrackFrequencyChangeParams) {
  ca('event', {
    action: 'Change',
    category: trackingPageType,
    label,
    name: 'oldevent',
    page,
  });
}
